import React from 'react';
import completeIcon from '../../Assets/complete.png';
import { useDispatch, useSelector } from 'react-redux';
import { message, Modal, Tooltip } from 'antd';
import { setIsReadOnly } from '../../Reducers/documentInfoSlice';
import { workwiseServices } from '../../Services/workWiseServices';

const { confirm } = Modal;

const CompleteDocument = () => {
    const dispatch = useDispatch();
    const { referenceId } = useSelector((state) => state.documentData.documentInformation);

    const handleClick = async () => {
        try {
            const response = await workwiseServices.completeDocument(referenceId);
            if (response && response.data.responseCode === 1001) {
                message.success('Document completed successfully.');
                dispatch(setIsReadOnly(true));
            } else {
                message.error('Failed to complete the document. Please try again.');
            }
        } catch (error) {
            message.error('Failed to complete the document. Please try again.');
        }
    };

    const showConfirmationModal = (e) => {
        e.preventDefault();
        confirm({
            title: 'Are you sure you want to complete this document?',
            content: 'This action cannot be undone.',
            onOk() {
                handleClick();
            },
            onCancel() { },
            zIndex: 9999,
            maskClosable: true,
        });
    };

    return (
        <Tooltip title='Complete document'>
            <div
                style={{ cursor: 'pointer' }}
                onClick={(e) => showConfirmationModal(e)}
            >
                <img src={completeIcon} width={22} alt="Complete Document" />
            </div>
        </Tooltip>
    );
};

export default CompleteDocument;
